import script from "./PageForbidden.vue?vue&type=script&setup=true&lang=js"
export * from "./PageForbidden.vue?vue&type=script&setup=true&lang=js"

import "./PageForbidden.vue?vue&type=style&index=0&id=22c96df0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c96df0"]])

export default __exports__